/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Vendor_Return_Waiting_On_TomorrowInputs */

const en_vendor_return_waiting_on_tomorrow = /** @type {(inputs: Vendor_Return_Waiting_On_TomorrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on Tomorrow · decision on your refusal · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on Tomorrow · decision on your refusal · since {since}" |
*
* @param {Vendor_Return_Waiting_On_TomorrowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_waiting_on_tomorrow = /** @type {((inputs: Vendor_Return_Waiting_On_TomorrowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Waiting_On_TomorrowInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_waiting_on_tomorrow(inputs)
});